(function() {

  // Declate variable
  var multicolumn = document.querySelector('.multicolumn');
  var counter = multicolumn.querySelectorAll('.count');
  var executed = false;

  const observer = new window.IntersectionObserver(([entry]) => {

    if (entry.isIntersecting && !executed) {
      for (let i = 0; i < counter.length; i++) {
        const element = counter[i];
        var elemStart = element.innerText;
        var elemEnd = element.getAttribute('data-value');
        countUp(element, elemStart, Number(elemEnd), 10);
      }
      executed = true;
      // console.log('ENTER', executed)
            return
    }
    // console.log('LEAVE')
  }, {
    root: null,
        threshold: 0.1, // set offset 0.1 means trigger if atleast 10% of element in viewport
    })

  observer.observe(multicolumn);

  function countUp(selector, min, max, duration) {
    var inter = setInterval(function() {
      selector.innerHTML = ++min;
      if (min >= max) {
        clearInterval(inter);
      }
    }, duration);
  }
  // Correction: Déclarez la fonction myFunction avant d'utiliser le DOMContentLoaded event listener
})();

if (document.querySelectorAll('.read-more').length > 0) {
  var readMoreButtons = document.querySelectorAll('.read-more');
  var readLessButtons = document.querySelectorAll('.read-less');
  for (let i = 0; i < readMoreButtons.length; i++) {
    readMoreButtons[i].addEventListener('click', function(){
      this.classList.add('hide');
    })
  }
  for (let i = 0; i < readLessButtons.length; i++) {
    readLessButtons[i].addEventListener('click', function(){
      this.previousElementSibling.previousElementSibling.classList.remove('hide');
    })
  }
}

// popup

window.addEventListener("DOMContentLoaded", (event) => {
  if (document.querySelectorAll('[data-open-lp-formulaire-popup]').length > 0) {
    var popupOpener = document.querySelectorAll('[data-open-lp-formulaire-popup]');
    var popup = document.querySelector('[data-lp-formulaire-popup]');
    var popupOverlay = document.querySelector('.lp-formulaire-popup__overlay');
    var popupClose = document.querySelector('[data-lp-formulaire-popup] .icon-close');

    for (let i = 0; i < popupOpener.length; i++) {
        const _popupOpener = popupOpener[i];
        _popupOpener.addEventListener('click', function(){
            popup.classList.add('active');
            popupOverlay.classList.add('active');
        })
    }

    popupOverlay.addEventListener('click', function(){
        popup.classList.remove('active');
        popupOverlay.classList.remove('active');
    })

    popupClose.addEventListener('click', function(){
        popup.classList.remove('active');
        popupOverlay.classList.remove('active');
    })
  }
})